<template>
  <div>
    <button class="btn btn-sm" :disabled="disabled"
      @click="downloadItem({url, name: name})">
      <slot></slot>
    </button>
  </div>
</template>
<script>
  import { errorNotify } from "@/plugins/functions";
  import { toFormData } from "@/_api/_helper";
  export default{
    props: {
      method: {
        default: 'get'
      },
      // disabled: {
      //   default: false
      // },
      name: {
        default: "",
      },
      url: {
        default: "",
      },
      params:{
        default: function(){
          return {};
        }
      },
    },
    data(){
      return {
        disabled: false,
      }
    },
    mounted(){
      console.log(this.params)
    },
    methods:{
      async downloadItem({ url, name }) {
        this.disabled = true;
        let params = this.params || {};

        try {
          let response;

          if (this.method === 'get') {
            response = await this.$http.get(url, {
              params,
              responseType: 'blob'
            });
          } else if (this.method === 'post') {
            response = await this.$http.post(
              url,
              toFormData({ ...params }),
              { responseType: 'blob' }
            );
          }

          const disposition = response.headers['content-disposition'];
          let filename = name; // твой дефолтный, если сервер не прислал
          console.log9(disposition, 'disposition')
          if (disposition && disposition.includes('filename=')) {
            const matches = disposition.match(/filename="?([^"]+)"?/);
            if (matches && matches[1]) {
              filename = matches[1];
            }
          }

          // Создание ссылки для скачивания
          const blob = new Blob([response.data], { type: response.data.type });
          console.log(response.data.name, response.data.filename)
          const link = document.createElement('a');
          link.href = URL.createObjectURL(blob);
          link.download = filename;
          link.click();
          URL.revokeObjectURL(link.href);

        } catch (error) {
          if (error.response && error.response.data) {
            error.response.data.text().then(e => {
              if (e) {
                errorNotify({ response: { data: JSON.parse(e) } }, this.$notify);
              }
            });
          }
        } finally {
          setTimeout(() => {
            this.disabled = false;
          }, 1000);
        }
      }
    }
  }
</script>